module.exports = __webpack_public_path__ + "img/imge13.60eda911.png";